export {MultiLineEllipsis} from './multiline-ellipsis';
export {cutTextPerLines} from './utils/cutTextPerLines';
